import styled from 'styled-components'

export default styled.h2`
    text-align:center;
    opacity:1;
    margin-top: 30px;
    margin-bottom: 30px;
    font-weight: 600;
    font-family:'Source Sans Pro',sans-serif;
    transition: transform .5s ease-out,opacity .5s ease-in-out;
    position:relative;
`